import { makeStyles } from '@branchjs/neo-components';

export const useStyles = makeStyles((theme) => ({
  card: {
    height: '520px',
    width: '615px',
    borderRadius: theme.spacing(1),
  },
  cardContent: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    margin: `${theme.spacing(4)}px ${theme.spacing(6)}px ${theme.spacing(7)}px`,
  },
  cardTitle: {
    ...theme.typography.h3,
    paddingBottom: 30,
    color: theme.colors.primary.main,
  },
  image: {
    alignSelf: 'center',
    marginBottom: `${theme.spacing(2.5)}px`,
  },
  resendEmailTextBlock: {
    width: '435px',
    alignSelf: 'center',
  },
  mainText: {
    ...theme.typography.body1,
    color: theme.colors.gray[800],
  },
  formInput: {
    textAlign: 'left',
    marginBottom: theme.spacing(3),
  },
}));
